<template>
  <div>
    <EditProjectPage />
  </div>
</template>

<script>
import EditProjectPage from '@/components/ai/hr-projects/EditProjectPage.vue';

export default {
  name: 'AIPage',
  components: {
    EditProjectPage
  },
  data() {
    return {
    };
  },
};
</script>
